import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=acc02282&scoped=true"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=acc02282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc02282",
  null
  
)

export default component.exports